export const ru = {
    'changes-confirm': 'Изменения не будут сохранены, продолжить?',
    'no-phrases-for-dynamic-campaigns': 'Нельзя добавлять фразы в группы Динамических кампаний',
    'no-phrases-for-smart-banners': 'Нельзя добавлять фразы в Смарт-баннерах',
    'refine-phrases-error': 'Во время загрузки фраз произошла ошибка. Попробуйте повторить действие ещё раз.',
    'refine-phrases-shows-error': 'Не удалось уточнить прогноз показов.',
    'start-phrases-error': 'Во время загрузки фраз произошла ошибка. Попробуйте обновить страницу и повторить ещё раз.'
};
